var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100 mx-0"},[(!_vm.loading)?_c('ViewTicket',{attrs:{"ticket-prop":_vm.ticket,"profiles":_vm.profiles,"profiles-map":_vm.profilesMap,"users":_vm.users,"tags":_vm.tags,"score-types":_vm.scoreTypes,"score-grades":_vm.scoreGrades}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }